/* Autoresize plugin that works with both jQuery and Ender */

define('core/extensions/jquery.autoresize',[
    'jquery',
    'underscore',
], function (
    $,
    _
) {
    'use strict';

    $.fn.autoresize = function (options) {

        // Just some abstracted details,
        // to make plugin users happy:
        var settings = _.extend({
            extraSpace: 0,
            maxHeight: 1000,
        }, options);

        // Only textarea's auto-resize:
        return this.each(function () {

            // Get rid of scrollbars and disable WebKit resizing:
            var textarea = $(this).css({ resize: 'none', 'overflow': 'hidden' });

            var method = String(textarea[0].contentEditable) === 'true' ?
                'html' : 'val';
            var newline = method === 'html' ? '<br>' : '\n';

            var origHeight = textarea.height();

            // Need clone of textarea, hidden off screen:
            var clone = (function () {
                // Create object of styles to apply:
                var props = {};
                _.each(props, function (__, prop) {
                    props[prop] = textarea.css(prop);
                });

                // Clone the actual textarea removing unique properties
                // and insert before original textarea:
                var cloned = $(textarea[0].cloneNode(true));

                cloned
                    .removeAttr('id')
                    .removeAttr('name')
                    .css({
                        visibility: 'hidden',
                        position: 'absolute',
                        top: '-9999px',
                        left: '-9999px',
                        contentEditable: false, // ignored if unsupported
                    })
                    .css(props)
                    .attr('tabIndex', '-1');

                cloned.insertAfter(textarea[0]);
                return cloned;
            })();

            var lastScrollTop = null;
            var updateSize = function () {
                // Prepare the clone:
                // don't know that we have to reset the height here...
                clone[0].style.height = 0;

                clone[method](textarea[method]() + newline);
                clone.scrollTop(clone[0].scrollHeight);

                // Find the height of text:
                var scrollTop = Math.max(clone[0].scrollHeight, origHeight) +
                    parseInt(settings.extraSpace, 10);


                if (settings.maxHeight) {
                    if (scrollTop >= settings.maxHeight) {
                        textarea.css('overflow', ''); // Scrollbars retrn
                        scrollTop = settings.maxHeight;
                    } else {
                        textarea.css('overflow', 'hidden'); // Remove scrollbars
                    }
                }

                // Don't do anything if scrollTip hasen't changed:
                if (lastScrollTop === scrollTop)
                    return;

                lastScrollTop = scrollTop;

                textarea.height(scrollTop);

                if (textarea.trigger)
                    textarea.trigger('resize');
            };

            var throttledUpdateSize = _.throttle(updateSize, 500);

            var handleKeyUp = function (evt) {
                // If the keypress is the enter/return key, always
                // update size. If it's a regular keypress (i.e. user
                // typing normally), then throttle.
                if (evt.keyCode === 13) // enter/return
                    updateSize();
                else
                    throttledUpdateSize();
            };

            // Bind namespaced handlers to appropriate events:
            textarea
                .bind('keyup', handleKeyUp)
                .bind('paste', updateSize)
                // potentially could have overflow default to hidden, and flip on instead
                .css('overflow', 'hidden');

            updateSize();
        });
    };

    return $;
});


